import { FuseLoadable } from '@fuse';

export const RelatorioConfig = {
    settings: {
        layout: {}
    },
    routes: [
        {
            path: '/:organizacao/:empresa/relatorio/:id',
            component: FuseLoadable({
                loader: () => import('./RelatorioApp')
            })
        }
    ]
};
